<template>
  <v-app id="app_measurements">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">CREATE & VIEW OUTLET TYPE</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">establish & access a new outlet types tailcred to you needs
            .</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8" elevation="1" border="true" rounded="lg">
        <v-card-text class="custom_tool_bar_style d-flex align-center">
          <div class="d-flex align-center flex-grow-1">
            <p class="custom_page_component_main_title ma-0">OUTLET TYPE DATA LIST</p>
          </div>
          <div class="d-flex align-center">
            <v-btn class="custom_measurement_btn" variant="outlined" @click="openDialog" v-if="permissions.write">
              &nbsp;&nbsp;CREATE NEW OUTLET TYPE
            </v-btn>
            <v-btn class="custom_pdf_btn ml-4" variant="outlined" @click="exportPDF">
              <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
            </v-btn>
            <v-btn class="custom_excel_btn ml-4" variant="outlined" @click="exportExcel">
              <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
            </v-btn>
          </div>
        </v-card-text>

        <v-divider class="my-2" style="height: 2px;"></v-divider>

        <!-- Number of measurement units -->
        <v-row align="center" justify="space-between">
          <!-- Left Side: Measurement Card -->
          <v-col cols="auto">
            <v-card elevation="1" class="pa-3 d-flex align-center">
              <div>
                <h1 class="custom_number_of_measurement_btn">{{ totalMeasurements }}</h1>
                <p class="font-weight-medium">NUMBER OF TYPES</p>
              </div>
            </v-card>
          </v-col>

          <!-- Right Side: Search Bar -->
          <v-col cols="12" md="4">
            <v-text-field v-model="search" append-inner-icon="mdi-magnify" clearable hide-details
                          label="Search" placeholder="Search Products" variant="outlined"
                          class="custom_input_field_color" density="comfortable"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-divider class="my-2" style="height: 2px;"></v-divider>

        <v-data-table
            :headers="headers"
            :items="measurementUnits"
            :search="search"
            :items-per-page="itemsPerPage"
            class="elevation-1"
        >
          <template v-slot:[`item.description`]="{ item }">
            {{ stripHtmlTags(item.description) }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu transition="slide-x-transition" id="app_product_list">
              <template v-slot:activator="{ props }">
                <v-btn class="custom_btn_primary" variant="flat" size="large" v-bind="props">
                  ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-if="permissions.write" @click="editMeasurement(item)">
                  <v-list-item-title class="custom_font_color_edit">EDIT</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                  <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>

        <v-pagination
            v-model="page"
            :length="totalPages"
            @input="changePage"
            class="my-4"
        ></v-pagination>

      </v-card>
      <v-dialog v-model="dialog" max-height="700" id="app_lead_list" max-width="600">
        <v-card rounded="md" style="overflow:hidden !important;">
          <div class="pa-4">
            <!-- Dialog Title -->
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">{{ dialogTitle }}</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="closeDialog" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <!-- Form Content -->
            <v-card-text>
              <v-form ref="form">
                <v-text-field
                    v-model="measurementName"
                    label="Outlet Type*"
                    placeholder="Type outlet type here"
                    variant="outlined"
                    required
                ></v-text-field>

                <v-text>Outlet Type Description</v-text>
                <v-card class="mt-5" elevation="1" border="sm opacity-1" rounded="lg" max-height="280" min-height="280">
                  <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode"/>
                  <v-divider></v-divider>
                  <Editor aria-placeholder="Type Hear..." v-model="valueHtml" :defaultConfig="editorConfig" :mode="mode"
                          @onCreated="handleCreated"/>
                </v-card>
              </v-form>
            </v-card-text>

            <!-- Action Buttons -->
            <v-card-actions class="d-flex justify-end">
              <v-btn color="primary" variant="flat" @click="saveMeasurement">{{ dialogButtonText }}</v-btn>
              <v-btn variant="outlined" @click="closeDialog">CANCEL</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="delete_measurement_dialog" max-height="500" max-width="500" persistent id="app_product_list">
        <v-card rounded="md">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat>
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE OUTLET TYPE</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="delete_measurement_dialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this OUTLET TYPE ?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                        This measurement will be deleted immediately. Once deleted, it can no longer be used for any purpose.
                        <span style="color: blue;">
                            Further, these modules are also related to the following others, so please read and confirm before deleting this.
                        </span>
                    </p>


                    
                    
                      <v-timeline align="start" density="compact">
                          <v-timeline-item>
                            <template v-slot:opposite> 
                              
                            </template>
                            <div>
                                <div class="text-h6">related area 01</div>
                                <p>
                                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                </p>
                              </div>
                          </v-timeline-item>

                          <v-timeline-item>
                            <template v-slot:opposite> 
                             
                            </template>
                            <div>
                                <div class="text-h6">related area 02</div>
                                <p>
                                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                </p>
                              </div>
                          </v-timeline-item>

                          <v-timeline-item>
                            <template v-slot:opposite> 
                             
                            </template>
                            <div>
                              <p>related area 02</p>
                            </div>
                          </v-timeline-item>

                          <v-timeline-item>
                            <template v-slot:opposite> 
                             
                            </template>
                            <div>
                              <p>related area 02</p>
                            </div>
                          </v-timeline-item>

                          <v-timeline-item>
                            <template v-slot:opposite> 
                             
                            </template>
                            <div>
                              <p>related area 02</p>
                            </div>
                          </v-timeline-item>

                          <v-timeline-item>
                            <template v-slot:opposite> 
                             
                            </template>
                            <div>
                              <p>related area 02</p>
                            </div>
                          </v-timeline-item>
                        </v-timeline>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4 ">
                  <v-btn class="custom_btn_primary" @click="deleteItems">DELETE</v-btn>
                  <v-btn class="ml-3 custom_btn_secondary" @click="delete_measurement_dialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>
      <!-- Measurement Bulk Upload Dialog -->
      <v-dialog v-model="MeasurementBulkUploadDialog" fullscreen id="app_add_leads">
        <v-card flat>
          <v-toolbar style="border-radius: 0px !important;"
                     class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo_full_5.png')"
                     @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="custom_red_btn" variant="flat" @click="MeasurementBulkUploadDialog = false">
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row class="mt-15  custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon>mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPLOAD SPREADSHEET
                  </v-card-title>
                </template>
              </v-card>

              <v-card class="px-3 mx-6 mt-3 custom_card_box" elevation="1" border="sm opacity-1" rounded="lg">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="12" md="5" lg="5">
                    <p class="text-body-1 font-weight-medium  mb-4 mt-4">
                      Upload your measurement bulk data set using excel or a csv file.
                    </p>
                    <v-divider></v-divider>
                    <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                      <v-file-input accept=".csv, .xls, .xlsx"
                                    clearable density="comfortable"
                                    class="custom_input_field_color mt-3" label="Upload your Excel or CSV file *"
                                    counter show-size variant="outlined"
                                    @change="handleFileUpload"></v-file-input>
                    </v-col>
                  </v-col>

                  <v-col class="d-flex align-center justify-center" cols="1">
                    <v-divider :thickness="2" vertical></v-divider>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <v-card class="d-flex align-center justify-space-between pa-4 mt-3" color="#F0F0F0" flat
                                width="100%">
                          <card class="mr-4" border="lg">
                            <p class="mb-0 text-body-2 font-weight-bold">DOWNLOAD SAMPLE TEMPLATE</p>
                          </card>
                          <v-divider vertical></v-divider>
                          <v-btn class="custom_btn_primary" size="x-large" variant="text" @click="downloadTemplate">
                            DOWNLOAD
                          </v-btn>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-card v-if="bulkItems.length > 0" flat>
                  <v-card-text>
                    <v-divider class="mb-4 "></v-divider>
                    <v-data-table :headers="bulkHeaders" :items="bulkItems" :items-per-page="itemsPerPage"
                                  class="custom_table_normal">
                      <template v-slot:[`item.subCategory`]="{ item }">
                        <span class="red--text">{{ item.subCategory }}</span>
                      </template>
                      <template v-slot:[`item.assignAgent`]="{ item }">
                        <span>{{ item.assignAgent }}<br/><span class="red--text">{{ item.regNum }}</span></span>
                      </template>
                    </v-data-table>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="float-end">
                    <v-btn :disabled="bulkItems.length === 0" class="custom_btn_primary  mt-2 mb-3" size="large"
                           variant="text" @click="uploadBulkMeasurement">Upload
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <!-- Snackbar to show notifications -->
      <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" location="top-right" outlined>
        {{ snackbarMessage }}

        <template v-slot:action="{ attrs }">
          <v-btn icon v-bind="attrs" @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>


      <!-- Snackbar to show notifications -->
      <v-snackbar v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight"
                  :top="snackAlert.snackBarTop" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
//This is related to wangeditor ---START
import "@wangeditor/editor/dist/css/style.css";
import { i18nChangeLanguage } from "@wangeditor/editor";
import axios from "axios";
i18nChangeLanguage("en");
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
// import { onBeforeUnmount, ref, shallowRef, onMounted } from "vue";
import {getPermissions} from "@/plugins/permissions";
import * as XLSX from "xlsx";

export default {
  components: {
    Editor,
    Toolbar,
  },

  
  name: 'MeasurementList',
  data() {
    return {
      permissions: {},
      search: "",
      page: 1,
      itemsPerPage: 10,
      dialog: false,
      dialogTitle: 'CREATE MEASUREMENTS',
      dialogButtonText: 'CREATE',
      measurementName: '',
      selectedProductId: null,
      unit: '',
      description: '',
      delete_measurement_dialog: false,
      MeasurementBulkUploadDialog: false,
      bulkFile: null,
      bulkItems: [],
      bulkHeaders: [
        {text: 'Measurement Name', value: 'Measurement Name', title: 'Measurement Name'},
        {text: 'Unit', value: 'Unit', title: 'Unit'},
        {text: 'Description', value: 'Description', title: 'Description'},
      ],
      bulkHeadersTwo: [
        {text: 'Measurement Name', value: 'Measurement Name', title: 'Measurement Name'},
        {text: 'Unit', value: 'Unit', title: 'Unit'},
        {text: 'Description', value: 'Description', title: 'Description'},
      ],
      headers: [
        {text: "OUTLET TYPE", value: "name", title: 'OUTLET TYPE', sortable: true},
        {text: "DESCRIPTION", value: "description", title: 'DESCRIPTION', sortable: true},
        {text: "ACTIONS", value: "actions", title: 'ACTIONS', sortable: true}
      ],
      measurementUnits: [
        { name: 'Kilogram', description: 'Weight measurement' },
        { name: 'Meter', description: 'Length measurement' },
        { name: 'Meter', description: 'Length measurement' }
      ],
      editingMeasurement: null,
      snackbar: false,
      snackbarColor: '',
      snackbarMessage: '',
      centerLoading: false,
      snackAlert: {
        snackbar: false, // Snackbar visibility
        snackColor: "", // Snackbar color
        snackMessage: "", // Snackbar message
        snackBarRight: false, // Snackbar position right
        snackBarTop: true,  // Snackbar position top
      },
    };
  },
  computed: {
    totalMeasurements() {
      return this.measurementUnits.length;
    },
    totalPages() {
      return Math.ceil(this.measurementUnits.length / this.itemsPerPage);
    }
  },
  methods: {

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    async uploadBulkMeasurement() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');

      // Validate file selection
      if (!this.bulkFile) {
        this.showSnackbar('No file selected for upload', 'error');
        console.error('No file selected for upload');
        return;
      }

      const formData = new FormData();
      formData.append('file', this.bulkFile);
      formData.append('userId', userId);

      this.isLoading = true; // Show loading state

      try {
        const response = await axios.post(
            `${process.env.VUE_APP_API_BASE_URL}/api/measurements/bulk-upload`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
        );

        // Handle success
        console.log('Bulk upload response:', response.data);
        this.showSnackbar('Bulk upload successful', 'success');
        window.location.href = "/measurement-list";
      } catch (error) {
        // Enhanced error handling
        if (error.response) {
          // Backend returned a status code
          const status = error.response.status;
          const message = error.response.data.error || 'An error occurred.';

          console.error(`Error ${status}: ${message}`);

          // Handle specific status codes
          switch (status) {
            case 400:
              this.showSnackbar(`Validation Error: ${message}`, 'error');
              break;
            case 401:
              this.showSnackbar('Unauthorized. Please log in again.', 'error');
              // Optionally redirect to login
              this.$router.push('/login');
              break;
            case 404:
              this.showSnackbar('User or resource not found.', 'error');
              break;
            case 500:
              this.showSnackbar('Server error. Please try again later.', 'error');
              break;
            default:
              this.showSnackbar(`Error: ${message}`, 'error');
          }
        } else if (error.request) {
          // No response received
          console.error('No response received:', error.request);
          this.showSnackbar('No response from the server. Please try again.', 'error');
        } else {
          // Other errors
          console.error('Error setting up request:', error.message);
          this.showSnackbar('An unexpected error occurred. Please try again.', 'error');
        }
      } finally {
        this.isLoading = false; // Hide loading state
      }
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      this.bulkFile = file;
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, {type: 'array'});

        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(worksheet, {header: 1});
        const headers = jsonData[0].map(header => header ? header.toString().trim() : '');

        const expectedHeaders = this.bulkHeadersTwo.map(header => header.text);

        const headersMatch = headers.length === expectedHeaders.length &&
            headers.every((header, index) => header === expectedHeaders[index]);
        console.log('Headers:', headers, 'Expected:', expectedHeaders);

        if (!headersMatch) {
          this.snackbar = true;
          this.snackbarMessage = 'UPLOADED FILE WAS WRONG';
          this.snackbarColor = 'error';
          return;
        }

        const isSerialDate = value => !isNaN(value) && value > 0 && value < 2958465; // Excel date range
        const excelDateToJsDate = serial => {
          const jsDate = new Date(Date.UTC(1900, 0, serial - 1)); // Subtract 1 for Excel's 1900 leap year bug
          return jsDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
        };

        const dataRows = jsonData.slice(1).map(row => {
          return headers.reduce((obj, header, index) => {
            let value = row[index];
            if (header === 'Assign Date' && isSerialDate(value)) {
              value = excelDateToJsDate(parseFloat(value));
            }
            obj[header] = value !== undefined && value !== null ? value.toString().trim() : '';
            return obj;
          }, {});
        });

        this.bulkItems = dataRows;
      };

      reader.readAsArrayBuffer(file);
    },

    async downloadTemplate() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      const url = `${process.env.VUE_APP_API_BASE_URL}/api/measurements/download-template?userId=${userId}`;


      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
        });

        if (!response.ok) {
          throw new Error('Failed to download template');
        }

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'template_measurement_data.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        this.showSnackbar("Template download successfully!", "success");
      } catch (error) {
        console.error('Error downloading template:', error);
      }
    },
    confirmDelete(item) {
      console.log('Deleting item:', item.id);
      this.selectedProductId = item.id;
      this.delete_measurement_dialog = true;
    },

    stripHtmlTags(html) {
      // Create a temporary div element
      const tempDiv = document.createElement("div");
      // Set the HTML content to the input
      tempDiv.innerHTML = html;
      // Return the text content without HTML tags
      return tempDiv.textContent || tempDiv.innerText || "";
    },

    fetchMeasurements() {
      const token = localStorage.getItem("token");
      console.log("token is ", token);

      axios.post(
          "/api/get/measurements",
          {}, // Request body (empty in this case)
          {
            headers: {
              'Authorization': `Bearer ${token}` // Ensure the token is prefixed with 'Bearer'
            }
          }
      )
          .then(response => {
            const data = response.data; // Axios automatically parses the JSON response
            this.measurementUnits = data.slice(0, 5); // Mocking API response
          })
          .catch(error => {
            console.error("Error fetching measurements:", error);
          });
    },
    openDialog() {
      this.dialogTitle = 'CREATE OUTLET TYPE';
      this.dialogButtonText = 'CREATE';
      this.measurementName = '';
      this.unit = '';
      this.valueHtml = '<p></p>'; // Reset valueHtml
      this.editingMeasurement = null;
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    async saveMeasurement() {
      if (!this.measurementName || !this.unit) {
        alert("Measurement Name and Unit are required!");
        return;
      }

      const measurement = {
        name: this.measurementName,
        unit: this.unit,
        description: this.valueHtml // Update description with valueHtml
      };

      const token = localStorage.getItem("token");

      if (this.editingMeasurement) {
        console.log("the edit id is ", this.editingMeasurement.id);
        // Update existing measurement
        try {
          const response = await axios.post(
              `/api/update/measurements/${this.editingMeasurement.id}`,
              measurement,
              {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              }
          );

          if (response.status === 200) {
            const index = this.measurementUnits.findIndex(m => m.id === this.editingMeasurement.id);
            this.measurementUnits.splice(index, 1, response.data);
            this.closeDialog();
          } else {
            alert("Failed to update measurement.");
          }
        } catch (error) {
          console.error("Error updating measurement:", error);
          alert("Failed to update measurement.");
        }
      } else {
        // Create new measurement
        try {
          const response = await axios.post(
              "/api/create/measurements",
              measurement,
              {
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              }
          );

          this.measurementUnits.push(response.data);
          this.closeDialog();
        } catch (error) {
          console.error("Error creating measurement:", error);
          alert("Failed to create measurement.");
        }
      }
    },
    editMeasurement(item) {
      this.dialogTitle = 'EDIT OUTLET TYPE';
      this.dialogButtonText = 'UPDATE';
      this.measurementName = item.name;
      this.unit = item.unit;
      this.valueHtml = item.description; // Update valueHtml with description
      this.editingMeasurement = item;
      this.dialog = true;
    },

    async deleteItems() {
      try {
        const token = localStorage.getItem("token");
        const ItemID = this.selectedProductId;

        const response = await axios.post(
            `/api/delete/measurements/${ItemID}`,
            {
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
        );

        if (response.status === 200) {
          this.measurementUnits = this.measurementUnits.filter(m => m.id !== this.selectedProductId);
        } else {
          alert("Failed to delete outlet type.");
        }
      } catch (error) {
        console.error("Error updating outlet type:", error);
        alert("Failed to update outlet type.sda");
      }



      //
      // axios.post(`/api/delete/measurements/${ItemID}`, {
      //   headers: {
      //     'Authorization': `Bearer ${token}`,
      //     'Content-Type': 'application/json'
      //   }
      // })
      //     .then(response => {
      //       if (response.status === 200) {
      //         // Remove the deleted measurement from the list
      //         this.measurementUnits = this.measurementUnits.filter(m => m.id !== this.selectedProductId);
      //       } else {
      //         alert("Failed to delete measurementss.");
      //       }
      //     })
      //     .catch(error => {
      //       console.error("Error deleting measurement:", error);
      //       alert("Failed to delete measurement.");
      //     });
    },

    exportPDF() {
      console.log("Exporting to PDF");

      const fileName = 'example.pdf';
      const file_type = 'pdf';
      this.logDocumentDownload(fileName,file_type);
    },
    exportExcel() {
      console.log("Exporting to Excel");

      const fileName = 'example.xlsx';
      const file_type = 'excel';
      this.logDocumentDownload(fileName,file_type);
    },


    async logDocumentDownload(fileName,file_type) {
      console.log(fileName);
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (!userId) {
          throw new Error('User ID not found');
        }

        // Asynchronous API call to log download
        const response = await axios.post(`/api/log-document-download`, {
          user_id: userId,
          file_type: file_type,
          file_name: fileName,
          entity_area: 'Outlet Management',

          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.status !== 200) {
          throw new Error('Failed to log download');
        }

        console.log('Download logged successfully');
      } catch (error) {
        console.error('Error logging download:', error);
      }
    },
    changePage(newPage) {
      this.page = newPage;
    },
    addProductsPageRoute() {
      console.log("Navigating to bulk upload");
    },
    backPageRoute() {
      console.log("Going back");
    }
  },
  mounted() {
    const dashboardId = 2;
    this.permissions = getPermissions(dashboardId);
    this.fetchMeasurements();
  }
}
</script>

